import { MultiStepWizard } from '../MultiStepWizard/MultiStepWizard'
import { MultiStepFacebookPlanningSchema } from '../schemas/FacebookPlanning'
import { MultiStepFacebookPlanningWizardProps } from './Types'
import { ChannelType } from 'components/CampaignCreationModal/Types'
import { ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'
import { ASPECT_RATIOS, DesignChannel } from 'components/NewFileModal/Types'
import { ContentPlanningProvider, useContentPlanningContext } from '../PlanningWizard/ContentPlanningContext'
import { ChooseTopic } from '../PlanningWizard/ChooseTopic/ChooseTopic'
import { SelectCaptions } from '../PlanningWizard/SelectCaptions/SelectCaptions'
import { PlanContent } from '../PlanningWizard/PlanContent/PlanContent'
import { useState } from 'react'
import { useFlipperFlag } from 'hooks/useFlipperFlag'
import { MediaType } from '../schemas/shared/mediaType'

const MultiStepFacebookPlanningWizard = (
  props: MultiStepFacebookPlanningWizardProps & {
    mediaType: string
    setMediaType: (mediaType: MediaType) => void
  },
) => {
  const { generateCampaign } = useContentPlanningContext()
  const { width, height } = ASPECT_RATIOS['facebook-post']
  const { mediaType, setMediaType } = props

  return (
    <MultiStepWizard.Root
      {...props}
      schema={MultiStepFacebookPlanningSchema}
      onSubmit={generateCampaign}
      initialValues={{
        ...props.initialValues,
        media_type: mediaType,
        width,
        height,
        source_visual_element_ids: props.initialValues?.source_visual_element_ids || [],
      }}
    >
      <ChooseTopic
        header="Enter a Topic for Your Facebook Posts"
        subHeader="Blaze will help you write and schedule a cluster of content around this topic linked to a Blaze campaign for easy reference."
        onChange={(values) => setMediaType(values.media_type)}
      />
      <SelectCaptions
        header="Select Facebook Posts"
        subHeader="Select posts related to your topic. You can edit them directly on this page."
        inputPlaceholder="Write your own post..."
        nextLabel={() => 'Plan'}
      />
      <PlanContent
        header="Plan Your Facebook Calendar"
        subHeader="Select a date and time for each of your posts or have Blaze pick for you."
        externalIntegrationType={ExternalIntegrationEnum.Facebook}
        previousLabel={mediaType === 'design' ? 'Templates' : 'Posts'}
      />
    </MultiStepWizard.Root>
  )
}

const MultiStepFacebookPlanningWizardContainer = (props: MultiStepFacebookPlanningWizardProps) => {
  const targetWriter = useFlipperFlag('writer_multiplanning')
  const [mediaType, setMediaType] = useState(
    props.initialValues?.media_type || (targetWriter ? MediaType.DocumentWithImages : MediaType.Design),
  )
  return (
    <ContentPlanningProvider
      captionsGenerationType={ChannelType.FacebookPost}
      generationType={mediaType === MediaType.Design ? DesignChannel.FacebookPost : ChannelType.FacebookPost}
      initialValues={props.initialValues}
    >
      <MultiStepFacebookPlanningWizard {...props} mediaType={mediaType} setMediaType={setMediaType} />
    </ContentPlanningProvider>
  )
}

export { MultiStepFacebookPlanningWizardContainer as MultiStepFacebookPlanningWizard }
